import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyBannerComponent } from './companyBanner.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CompanyBannerComponent],
  exports: [CompanyBannerComponent],
})
export class CompanyBannerModule {}
